export const TYPES = {
  PARAGRAPH: 'paragraph',
  SUBHEADER: 'subheader',
  LIST: 'list',
}

export type MarkdownContent = {
  type: string
  content: string | string[]
} | null

export const parseMarkdown = (str: string): MarkdownContent => {
  if (!str) {
    return null
  }

  if (str.match('### ')) {
    return { type: TYPES.SUBHEADER, content: str.slice(4) }
  } else if (str.slice(0, 2) === '- ') {
    return { type: TYPES.LIST, content: str.slice(2).split('\n- ') }
  } else {
    return {
      type: TYPES.PARAGRAPH,
      content: str,
    }
  }
}
